import * as types from '../actiontypes';
import env from '../../util/env';
import {serviceURL} from '../../util/uiconstants';

export function getEngagementUser(engagementId, projectId) {
	let baseUrl = env.getBaseURL(serviceURL);
	let url = `${baseUrl}projects/${projectId}/engagementUsers?engagementIds=${engagementId}`;

	return {
		type: types.GET_ENGAGEMENT_USER,
		meta: {
			api: {
				url: url,
				method: 'GET'
			}
		},
		engagementId
	};
}
